import type { QueryClient } from "@tanstack/react-query";
import { EntryType } from "@/openapi/generated/models";
import { QueryKeys } from "@/lib/types";
import type { MediaAssetQueryScope } from "@/lib/utils/media/media-asset-query-key";

const MEDIA_SCOPES: MediaAssetQueryScope[] = ["auth", "public"];

export async function invalidateTeacherMediaQueries(
  queryClient: QueryClient,
  tenantId: number,
  teacherId: number,
) {
  await Promise.all(
    MEDIA_SCOPES.map((scope) =>
      queryClient.invalidateQueries({
        queryKey: [
          QueryKeys.MediaAsset,
          scope,
          tenantId,
          EntryType.Teacher,
          teacherId,
        ],
        exact: false,
      }),
    ),
  );
}

/** Refresh every teacher image cache after a profile upload (tenant-global media ids). */
export async function invalidateAllTeacherMediaQueries(
  queryClient: QueryClient,
  tenantId: number,
) {
  await Promise.all(
    MEDIA_SCOPES.map((scope) =>
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.MediaAsset, scope, tenantId, EntryType.Teacher],
        exact: false,
      }),
    ),
  );
}
